export default __webpack_public_path__ + "static/media/agrifi.82cf88b6.md";